import { TicketDiscount, TicketRatesDiscount } from "../types/property";

export const checkFillDiscountRates = (discount: boolean, data: Array<TicketRatesDiscount> | undefined): boolean => {
    if (discount && data) {
        if (data.length === 0) {
            return true
        }
    }
    return false
}

export const checkFillDiscount = (discount: boolean, data: TicketDiscount | undefined): boolean => {
    if (data) {
        if (Object.keys(data).length === 0  && discount) {
            return true
        }
        if (discount && isNaN(data.newPrice) || isNaN(data.percent)) {
            return true
        }
    }
    return false
}

export const checkDiscountPreviousValue = (data: Array<TicketRatesDiscount> | undefined): boolean => {
    if (data) {
        for (let index = 1; index < data.length; index++) {
            if (data[index - 1].amountTickets >= data[index].amountTickets) {
                return true
            }
        }
    }
    return false
}

export const checkDiscountValues = (discountCategory: string, data: Array<TicketRatesDiscount> | undefined): boolean => {
    if (data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].amountTickets < 0 || data[i].percent < 0 || isNaN(data[i].amountTickets) || isNaN(data[i].percent) || !data[i].percent) {
                return true
            }
            if (discountCategory === "percent" && data[i].percent > 99) {
                return true
            }
            if (data[i].newPrice < 0.01) {
                return true
            }

        }
    }
    return false
}

export const checkIsCash = (discountCategory: string, data: Array<TicketRatesDiscount>| undefined): TicketRatesDiscount[] | undefined => {
    if (data) {
        if (discountCategory === "cash") {
            for (let index = 0; index < data.length; index++) {
                const percent = data[index].percent;
                data[index].percent = data[index].newPrice;
                data[index].newPrice = percent
            }
            return data
        }
    }
    return data
}

export const comeBackIsCash = (data: Array<TicketRatesDiscount>): Array<TicketRatesDiscount> => {
    for (let index = 0; index < data.length; index++) {
        const percent = data[index].percent;
        data[index].percent = data[index].newPrice;
        data[index].newPrice = percent
    }
    return data
}